import React from "react";
import {
  ActiveStockOrderContext,
  ActiveStockOrderItemContext,
  ActiveStockOrderType,
} from "./context";
import { StockOrder } from "@towersystems/roam-common/lib/generated-types";

export const useStockOrder = (stockOrder: StockOrder): ActiveStockOrderType => {
  const [activeStockOrder, _setActiveStockOrder] = React.useState(stockOrder);

  const setStockOrder = React.useCallback(
    (stockOrder: StockOrder) => {
      _setActiveStockOrder(stockOrder);
    },
    [_setActiveStockOrder]
  );

  return {
    stockOrder: activeStockOrder,
    setStockOrder,
  };
};
export const useStockOrderContextProvider = () => {
  const context = React.useContext(ActiveStockOrderContext);
  if (!context) {
    throw new Error("No ActiveStockOrderContext context was provided.");
  }
  return context;
};

export const useActiveStockOrderItemProvider = () => {
  const context = React.useContext(ActiveStockOrderItemContext);
  if (!context) {
    throw new Error("No ActiveStockOrderItemContext context was provided.");
  }
  return context;
};
